import React from 'react';
import PropTypes from 'prop-types';
import PropertyDetailContact, { isValidContact } from '../../PropertyDetailContact/PropertyDetailContact';
import ConditionalWrapper from '../../../ConditionalWrapper/ConditionalWrapper';
import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

import '.././PropertyDetailBasicInfo.css';

export function BrokerRealtorContacts({
  contacts,
  viewer,
}) {
  const { broker } = contacts;
  // Per requirements, we only want up to two contacts to appear
  const overviewSectionsToShow = viewer.buildingSettings.overviewSectionsToShow;

  return (
    <ConditionalWrapper condition={isValidContact(broker) && (!overviewSectionsToShow || overviewSectionsToShow.includes('Broker'))}>
      <section>
        <ViewerPrimaryColorUserStyle domStyle="color">
          <h4 className="section-title">Broker/Realtor Contact</h4>
        </ViewerPrimaryColorUserStyle>
        <PropertyDetailContact
          className="section-body"
          contact={broker}
        />
      </section>
    </ConditionalWrapper>
  );
}

BrokerRealtorContacts.propTypes = {
  contacts: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default BrokerRealtorContacts;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailBasicInfo/BrokerRealtorContacts/BrokerRealtorContacts.js